module.exports = __webpack_public_path__ + "static/media/f01_3.4a95fac5.png";